"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAFF_ROLES = void 0;
exports.isStaffRole = isStaffRole;
exports.parseRoleTags = parseRoleTags;
/**
 * Constant array of all valid StaffRoleTag values.
 * Used for validation and iteration.
 */
exports.STAFF_ROLES = [
    'teacher',
    'admin',
    'co_teacher',
    'dsl',
    'deputy_dsl',
    'sendco',
    'ect',
];
/**
 * Type guard: returns true if the value is a valid StaffRoleTag.
 */
function isStaffRole(value) {
    return typeof value === 'string' && exports.STAFF_ROLES.includes(value);
}
/**
 * Converts a string[] from the DB (role_tags TEXT[] column) to a typed
 * StaffRoleTag[], filtering out any invalid values. This is defensive
 * against DB corruption — if a row somehow contains an invalid tag, it
 * is silently dropped rather than causing a runtime error.
 *
 * Handles null/undefined input gracefully (returns []).
 */
function parseRoleTags(values) {
    if (!values || !Array.isArray(values))
        return [];
    return values.filter(isStaffRole);
}
